import Reveal from "@/components/base/Reveal";
import { aboutStats } from "@/mocks/siteData";

export default function AboutSection() {
  return (
    <section id="about" className="bg-background-50 py-20 md:py-28">
      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 items-center gap-12 px-4 md:px-6 lg:grid-cols-2 lg:gap-16">
        <Reveal>
          <div className="flex items-center gap-3">
            <span className="h-px w-6 bg-primary-500/70" />
            <span className="font-label text-xs md:text-sm text-primary-400">
              About · 연안 도산센터
            </span>
          </div>
          <h2 className="font-heading mt-5 text-2xl leading-[1.3] text-foreground-950 sm:text-3xl sm:leading-[1.35] md:text-4xl">
            다시 시작해도
            <br />
            결코 늦지 않았습니다
          </h2>
          <p className="mt-6 text-sm md:text-base leading-relaxed text-foreground-600">
            연안법무법인은 개인회생·개인파산에 집중하는 도산 전문 조직입니다.
            대한변호사협회에{" "}
            <b className="font-medium text-primary-400">도산 분야 전문변호사로 등록</b>된
            대표변호사가 상담부터 인가·면책까지 직접 챙깁니다.
          </p>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
            획일적인 처리가 아닌, 한 분의 소득·채무·재산 구조를 정밀하게 분석해 감당
            가능한 변제안을 설계합니다.
          </p>

          <div className="mt-8 grid grid-cols-3 gap-3 md:gap-5">
            {aboutStats.map((stat) => (
              <div
                key={stat.label}
                className="rounded-lg border border-background-200/70 bg-background-100/60 px-3 py-4 text-center md:px-4"
              >
                <b className="font-heading block text-xl md:text-2xl font-semibold text-primary-400">
                  {stat.value}
                </b>
                <span className="mt-1 block text-xs text-foreground-500 md:text-sm">
                  {stat.label}
                </span>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={120}>
          <div className="relative overflow-hidden rounded-lg border border-background-200/70">
            <div className="h-[360px] w-full md:h-[480px]">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20confident%20Korean%20female%20attorney%20in%20her%20forties%20wearing%20an%20elegant%20dark%20suit%2C%20composed%20expression%2C%20soft%20golden%20rim%20light%20against%20a%20deep%20charcoal%20studio%20backdrop%2C%20editorial%20corporate%20photography%2C%20high%20detail%2C%20refined%20and%20trustworthy%20mood&width=900&height=1200&seq=yeonan-attorney-portrait-01&orientation=portrait"
                alt="연안법무법인 대표변호사 프로필"
                title="연안법무법인 도산 전문 대표변호사"
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="absolute inset-x-0 bottom-0 flex items-end justify-between bg-gradient-to-t from-background-50 via-background-50/70 to-transparent px-5 pb-5 pt-16">
              <div>
                <div className="font-label text-[10px] text-primary-400">Attorney</div>
                <div className="mt-1 font-subheading text-lg font-semibold text-foreground-950">
                  김연안 <span className="text-sm font-normal text-foreground-500">대표변호사</span>
                </div>
              </div>
              <i className="ri-scales-3-line text-2xl text-primary-500/70" />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}